import { render, staticRenderFns } from "./bekannt-von.vue?vue&type=template&id=50417d34&lang=pug&"
import script from "./bekannt-von.vue?vue&type=script&lang=js&"
export * from "./bekannt-von.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports